import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { ContentRequestsRouteState } from 'src/app/content-requests/_models';
import { SortConfig } from 'src/app/shared/view-models/sort-config';
import { AppStateService, UtilitiesService } from '../../core/services';
import { SearchFilterPipe } from '../../shared/pipes';
import { CsrTasksView } from './_models/csr-tasks-view';
import { ApiUrlsService, CsrTasksService, ViewStateService } from './_services';

@Component({
	selector: 'st-csr-tasks',
	templateUrl: './csr-tasks.component.html',
	providers: [SearchFilterPipe]
})
export class CsrTasksComponent implements OnInit {
	public byClientSearchResults: CsrTasksView[];
	public spinnerActive: boolean;
	public tasks: CsrTasksView[];
	sortConfig: SortConfig = {
		column: '',
		direction: 'asc'
	};

	private searchTermChanged: Subject<string> = new Subject<string>();
	private subs: Subscription[] = [];

	constructor(
		public apiUrlsService: ApiUrlsService,
		private appStateService: AppStateService,
		public csrTasksService: CsrTasksService,
		private router: Router,
		private searchFilterPipe: SearchFilterPipe,
		public utilService: UtilitiesService,
		public viewStateService: ViewStateService
	) {
		this.searchTermChanged.pipe(debounceTime(400)).subscribe(() => {
			this.getTasks();
		});
	}

	ngOnInit() {
		this.setRouteState();
		this.getTasks();
	}

	public getSortIconClass(column: string): string {
		if (this.sortConfig.column !== column) {
			return 'fas fa-sort';
		}
		return this.sortConfig.direction === 'desc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
	}

	getPage(pageNumber: number): void {
		this.viewStateService.state.pageNumber = pageNumber;
		if (this.viewStateService.state.route === 'my-tasks') {
			this.getTasks();
		}
	}

	onCheckboxClick(str: string): void {
		this.viewStateService.state[str] = !this.viewStateService.state[str];
		if (str === 'dateRange') {
			this.viewStateService.state.showPast = false;
			this.viewStateService.state.showTodayAndFuture = false;
			if (this.viewStateService.state.dateRange) {
				this.tasks.length = 0;
			} else {
				this.getTasks();
			}
		} else {
			this.getTasks();
		}
	}

	public onDateRangeGoClick(): void {
		this.getTasks();
	}

	public onSearchKeyup(): void {
		if (this.viewStateService.state.route === 'my-tasks') {
			this.searchTermChanged.next(this.viewStateService.state.searchTerm);
		} else if (this.viewStateService.state.route === 'by-client') {
			this.byClientSearchResults = this.searchFilterPipe.transform(this.tasks, this.viewStateService.state.searchTerm);
			this.csrTasksService.totalItems = this.byClientSearchResults.length;
		}
	}

	public onSearchClear(): void {
		this.viewStateService.state.searchTerm = '';
		if (this.viewStateService.state.route === 'my-tasks') {
			this.getTasks();
		} else if (this.viewStateService.state.route === 'by-client') {
			this.csrTasksService.totalItems = this.tasks.length;
		}
	}

	public onSortClick(newConfig: SortConfig) {
		this.sortConfig = newConfig;
		this.viewStateService.state.orderByCol = this.sortConfig.column;
		if (this.sortConfig.direction === 'asc') {
			this.viewStateService.state.orderDesc = false;
			this.sortConfig.direction = 'desc';
		} else {
			this.viewStateService.state.orderDesc = true;
			this.sortConfig.direction = 'asc';
		}
		this.getTasks();
	}

	public onNewTaskClick(): void {
		this.router.navigate([`/new-csr-task/${this.appStateService.currentClient.Id}`]);
	}

	public getTasks(): void {
		this.spinnerActive = true;
		this.csrTasksService.getTasks(this.viewStateService.state.route).subscribe((tasks: CsrTasksView[]) => {
			this.tasks = tasks;
			this.spinnerActive = false;
		});
	}

	private setRouteState(): void {
		if (this.utilService.includes(this.appStateService.activeUrl, ContentRequestsRouteState.SYSTEM_TOOLS)) {
			this.viewStateService.state.route = 'my-tasks';
		} else {
			this.viewStateService.state.route = 'by-client';
		}
	}
}
